// Provides an easy way to apply bindings to attributes with the 'bindOnAttribute' function
// The function will look for elements with your attribute,
// parse the options based on conventions and pass the resulting
// options object to your callback.
//
// options added to the base binding will be parse onto the 'base' property
// the binding will also find all attribute with the binding as its prefix and parse those too
// json is a valid input and will be parsed also
// Example: <div data-example-binding="text" data-example-binding-prop="something" data-example-binding-otherprop='{"subprop":3}'>
// will parse into:
// { "base": "text", "prop": "something", "otherprop": { "subprop":3 } }


var BindingStore = [];

function parseJsonOrReturn (attribute) {
    if (attribute[0] && attribute[0] === '{') {
        try {
            const obj = JSON.parse(attribute);

            if (obj && typeof obj === 'object') {
                return obj;
            }
        } catch (e) {
            return attribute;
        }
    }

    return attribute;
}

function parseOptions (element, attribute) {
    const options = {};
    options.base = parseJsonOrReturn(element.getAttribute(attribute));
    for (let j = 0; j < element.attributes.length; j++) {
        const { name } = element.attributes[j];
        if (name.indexOf(attribute) === 0) {
            const suffix = name.substring(attribute.length + 1);
            const camelCaseSuffix = suffix.replace(/-([a-z])/gi, ($0, $1) => $1.toUpperCase());
            options[camelCaseSuffix] = parseJsonOrReturn(element.attributes[j].value);
        }
    }
    return options;
}

function bindToElement (parentElement, attribute, bindFunc) {
    const elements = parentElement.querySelectorAll(`[${attribute}]`);

    for (let i = 0; i < elements.length; ++i) {
        const element = elements[i];
        const options = parseOptions(element, attribute);

        bindFunc(element, options);
    }
}

function bindOnAttribute (attribute, bindFunc, doc) {
    const localDoc = doc || document;

    BindingStore.push({
        attribute,
        bindFunc
    });

    const domAlreadyLoaded = localDoc.readyState === 'complete'
        || localDoc.readyState === 'loaded'
        || localDoc.readyState === 'interactive';
    if (domAlreadyLoaded) {
        bindToElement(localDoc, attribute, bindFunc);
    } else {
        localDoc.addEventListener('DOMContentLoaded', () => {
            bindToElement(localDoc, attribute, bindFunc);
        });
    }
}

function applyBindings (element) {
    for (let i = 0; i < BindingStore.length; ++i) {
        const binding = BindingStore[i];
        bindToElement(element, binding.attribute, binding.bindFunc);
    }
}

export default { bindOnAttribute, applyBindings };
